/**
 * Analysis: Team Leader (management_id 1) or Game Management bureau (bureau_id 2) manage all.
 * Other members: public analyses only (API + UI filter). Admins are not elevated.
 */

export function canManageAnalyses(user) {
  if (!user) return false;
  const isTL = Boolean(user.is_team_leader) || Number(user.management_id) === 1;
  const isGameBureau = Number(user.bureau_id) === 2;
  return isTL || isGameBureau;
}

export function canViewPrivateAnalyses(user) {
  return canManageAnalyses(user);
}
